import { useCallback } from 'react'

import { useFlag } from '@acre/utils'

import { userType } from './constants'

type RoleFields = {
  primary_role_id?: Maybe<string>
  role_name?: Maybe<string>
}

// Role names arrive from the backend, where the support and importer roles
// still carry the Acre brand. The rebranded name is resolved by role id so the
// rendered name follows the flag whatever the backend returns.
const scoreRoleNames: Record<string, string> = {
  [userType.acreImporter]: 'Score Importer',
  [userType.readOnlySupport]: 'Score Support Read Only',
  [userType.modifySupport]: 'Score Support Modification',
}

export const getRoleDisplayName = ({ primary_role_id, role_name }: RoleFields, isScoreRebrand: boolean) => {
  const scoreName = primary_role_id ? scoreRoleNames[primary_role_id] : undefined

  return isScoreRebrand && scoreName ? scoreName : role_name
}

export const useRoleDisplayName = () => {
  const isScoreRebrand = useFlag('feature.score_rebrand', false)

  return useCallback((role: RoleFields) => getRoleDisplayName(role, isScoreRebrand), [isScoreRebrand])
}

// Support users are identified by role id: the role name is brand-dependent.
const supportRoleIds: string[] = [userType.readOnlySupport, userType.modifySupport]

export const isSupportRole = (primary_role_id?: Maybe<string>) =>
  !!primary_role_id && supportRoleIds.includes(primary_role_id)
